// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2qs4P","disabled":"FileBtn_disabled__1ND3K","warn":"FileBtn_warn__3Mh6H","fade":"FileBtn_fade__1YMy4"};